import React, { useState } from 'react';

function CustomSelect({ items, value, onChange }) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <div className="main_custom_select" onMouseLeave={() => setIsOpen(false)}>
        <button
          className="select_button"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <span>{value}</span>
          <img 
            draggable="false" 
            src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/chevron_down.svg?v=1713943521" 
            alt="chevron down" 
          />
        </button>
        {isOpen && (
          <div className="items_container">
            {items?.map((item, idx) => (
              <button
                className="item"
                onClick={() => {
                  onChange(item.value);
                  setIsOpen(false);
                }}
                key={idx}
              >
                {item.label}
              </button>
            ))}
          </div>
        )}
      </div>
      <style jsx>
        {`
          .main_custom_select {
            font-size: 13px;
            position: relative;
          }
          .select_button {
            text-transform: capitalize;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-sizing: border-box;
            height: 48px;
            width: 312px;
            border: 1px solid #242424;
            border-radius: 2px;
            background-color: #141414;
            color: #e4e4e4;
            font-family: 'Roboto-Medium';
            outline: none;
            cursor: pointer;
            padding: 14px;
          }

          .items_container {
            border-radius: 2px;
            position: absolute;
            top: 48px;
            bottom: 0;
            left: 0;
            z-index: 1;
          }
          .item {
            text-transform: capitalize;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-sizing: border-box;
            height: 48px;
            width: 312px;
            border: 1px solid #242424;
            border-radius: 2px;
            background-color: #141414;
            color: #e4e4e4;
            font-family: 'Roboto-Medium';
            outline: none;
            cursor: pointer;
            padding: 14px;
          }
          .item:hover,
          .item:focus {
            background-color: #950810;
          }

          @media (max-width: 767px) {
            .select_button,
            .item {
              width: ;
            }
          }
        `}
      </style>
    </>
  );
}

export default CustomSelect;
